import { render, staticRenderFns } from "./SearchResultNftTable.vue?vue&type=template&id=13ea780e&scoped=true"
import script from "./SearchResultNftTable.vue?vue&type=script&lang=js"
export * from "./SearchResultNftTable.vue?vue&type=script&lang=js"
import style0 from "./SearchResultNftTable.vue?vue&type=style&index=0&id=13ea780e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ea780e",
  null
  
)

export default component.exports